import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import SelfDevelopmentUsersTable from './SelfDevelopmentUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySelfDevelopmentUsers } from './companySelfDevelopmentApi';

/**
 * Company Self Development → Employees/Members list.
 * Every user of the current population appears (those who have never opened the
 * section show dashes and sort last); a row opens their practice across all six
 * tools.
 */
const CSelfDevelopmentUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanySelfDevelopmentUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Self Development — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and the self-development tools they use. Open
        a user to see how much they have built — never what they wrote.
      </p>

      <SelfDevelopmentUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/self-development/user?userId=${rowData?._id}`)}
        tableName="company_self_development_users"
      />
    </div>
  );
};

export default CSelfDevelopmentUsers;
